






































































import { Component, Prop } from 'vue-property-decorator';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';
import { SwExtendedVue } from '../sw-extended-vue';

const cssPrefix = 'sw-bar-progress';

@Component({
  components: {},
})
export default class SwBarProgress extends SwExtendedVue {
  @Prop({ type: Number, default: 0 })
  value: number;

  @Prop({ type: Number, default: 100 })
  max: number;

  @Prop({ type: Boolean, default: true })
  withLabel: boolean;

  @Prop({ type: Number, default: undefined })
  barWidth: number | undefined;

  @Prop({ type: Boolean, default: undefined })
  noBorder: boolean;

  @Prop({ type: String, default: utilService.colorConst.statusSuccess })
  color: string;

  @Prop({ type: String })
  baseColor: string;

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  cssPrefix = cssPrefix;

  /** two digits after point if exist */
  get progressPercentage(): number {
    return Math.floor(this.value * 100 * 100 / this.max) / 100;
  }

  get progressStyle(): CSSStyleOptions {
    return {
      width: `${this.progressPercentage}%`,
      backgroundColor: this.color,
    };
  }

  get baseStyle(): CSSStyleOptions {
    return {
      width: !!this.barWidth ? `${this.barWidth}px` : undefined,
      backgroundColor: this.baseColor || undefined,
    };
  }

  get effectiveNoBorder(): boolean {
    if (typeof this.noBorder === 'boolean') { return this.noBorder; }
    return this.theme === 'dark';
  }
}
